module.exports = __webpack_public_path__ + "media/images/import-guide-3-634da0f9ff2438d713af0d906d34ebcd.svg";